// extracted by mini-css-extract-plugin
export var textInput = "_kg-0";